/**
 * Savings List Page
 */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { fetchSavings } from '../savingsSlice';
import Button from '../../../components/common/Button/Button';
import { ROUTES } from '../../../constants/routes';

const SavingsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { accounts, isLoading } = useSelector((state) => state.savings);

  useEffect(() => {
    dispatch(fetchSavings());
  }, [dispatch]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Savings Accounts</h1>
          <p className="text-gray-600 dark:text-gray-400">Manage member savings accounts</p>
        </div>
        <Button variant="primary" onClick={() => navigate(ROUTES.SAVINGS.CREATE)}>
          <Plus className="w-4 h-4 mr-2" />
          New Account
        </Button>
      </div>

      {isLoading ? (
        <div className="text-center py-8">Loading...</div>
      ) : (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
          {accounts.length > 0 ? (
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead className="bg-gray-50 dark:bg-gray-800">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Account</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Member</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Balance</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Type</th>
                </tr>
              </thead>
              <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                {accounts.map((account) => (
                  <tr key={account.id}>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-white">{account.accountNumber}</td>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-white">{account.member?.firstName} {account.member?.lastName}</td>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-white">{account.balance}</td>
                    <td className="px-6 py-4 text-sm text-gray-900 dark:text-white capitalize">{account.type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-center py-8 text-gray-500">No savings accounts found</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SavingsList;
